module.exports = __webpack_public_path__ + "img/footer.986a2192.jpg";